import { useState, useRef } from 'react'
import { getBodyScrollTop } from '../utils/helper'
import smoothScroll from '../utils/smoothScroll'

const useDisplayGroup = ({ isMobile }) => {
    const [displayGroup, setDisplayGroup] = useState(-1)
    const refChangeByClick = useRef(false)

    const handleSetDisplayGroup = (group, cb) => {
        const elmnt = document.getElementById(`group-${group}`)
        if (elmnt) {
            const { offsetTop } = elmnt
            const gap = isMobile ? 60 : 76
            // getBodyScrollTop().scrollTop = offsetTop - gap
            smoothScroll.top(getBodyScrollTop(), offsetTop - gap, {
                duration: 0
            }, cb)
        }

        setDisplayGroup(group)
    }

    return {
        handleSetDisplayGroup,
        displayGroup,
        setDisplayGroup,
        refChangeByClick,
    }
}

export default useDisplayGroup
